import { JSX } from "react";

import { IdentitySource } from "@/@types/divergence";

import { IDENTITY_RULE_ACK } from "../../utils/messages";

export const IDENTITY_RULE_ACK_TEST_ID: string = "identity-rule-ack";

interface IdentityRuleAcknowledgeProps {
  source: IdentitySource;
  acknowledged: boolean;
  onAcknowledge: (value: boolean) => void;
}

export function IdentityRuleAcknowledge({
  source,
  acknowledged,
  onAcknowledge,
}: IdentityRuleAcknowledgeProps): JSX.Element | null {
  const label: string | null = IDENTITY_RULE_ACK[source];

  if (!label) return null;

  return (
    <label className="flex cursor-pointer items-start gap-2 rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900">
      <input
        type="checkbox"
        data-testid={IDENTITY_RULE_ACK_TEST_ID}
        className="mt-0.5"
        checked={acknowledged}
        onChange={(event): void => onAcknowledge(event.target.checked)}
      />
      <span>{label}</span>
    </label>
  );
}
